import API from '../dataApi';

export const getTrialPlans = () => API.get('/trial-accounts/plans');
export const getTrialAccounts = () => API.get('/trial-accounts');
export const createTrialAccount = (data) => API.post('/trial-accounts', data);
